import { Env } from '@prenuvo/nimbus-logger';

const envMap = {
  local: Env.loc,
  development: Env.dev,
  staging: Env.stg,
  production: Env.prd,
};

/**
 * Standardize the environment string to the Env enum
 * @param {string | undefined} env - The environment string to standardize.
 * @returns {Env} The standardized environment as an Env enum value.
 */
export function standardizeEnv(env: string | undefined): Env {
  if (!env) {
    return Env.loc;
  }

  const envLower = env.toLowerCase();

  // match the key (full name)
  if (Object.keys(envMap).includes(envLower)) {
    // @ts-ignore
    return envMap[envLower];
  }

  // match the value (abbr name)
  if (Object.values(envMap).includes(envLower as Env)) {
    return envLower as Env;
  }

  return Env.loc;
}
